import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'

import { getHarmonyFolderCollection } from '../getCollections'

const logger = useRhythmicLogger('useHarmonyPlanContext:deleteFolder')

export function handleDeleteHarmonyPlanFolder(
  folderId: string,
  context: {
    workspaceId: string
    planId: string
  },
): Transaction {
  if (!folderId) throw new Error('Folder identifier is required to delete a harmony plan folder')

  const { workspaceId, planId } = context

  if (!workspaceId) throw new Error('Workspace identifier is required to delete a harmony plan folder')

  if (!planId) throw new Error('Harmony plan identifier is required to delete a folder')

  const collection = getHarmonyFolderCollection(planId)

  try {
    const transaction = collection.delete(folderId)
    logger.info('Harmony plan folder deleted', {
      planId,
      workspaceId,
      folderId,
    })
    return transaction
  } catch (error) {
    logger.error('Failed to delete harmony plan folder', {
      planId,
      workspaceId,
      folderId,
      error,
    })
    if (error instanceof Error) throw error

    throw new Error('Failed to delete harmony plan folder', { cause: error })
  }
}
